import { memo } from 'react';
import { PasswordEditTemplate } from 'components/templates/PasswordEditTemplate';

type Props = {};

export const PasswordEditPage = memo((_props: Props) => {
	return <PasswordEditTemplate />;
});
